var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlustra404Eudora(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 119 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ilustra-404-eudora_svg__paint0_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.405 19.006l-3.279-2.454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ilustra-404-eudora_svg__paint1_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M98.574 20.816l3.589-2.978"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ilustra-404-eudora_svg__paint2_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M104.549 52.134l12.502-.277"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ilustra-404-eudora_svg__paint3_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.978 52.134l12.502-.277"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ilustra-404-eudora_svg__paint4_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M60.824 14.529V1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.893 44.185v4.175c0 1.023-.336 1.79-1.092 2.471-1.597 1.449-3.53 2.216-5.548 2.727-1.933.596-3.95.937-5.968 1.363-.757.17-1.009.426-1.009 1.193v8.18c0 1.023.42 1.79 1.345 2.3A37.574 37.574 0 0187.137 76.65c3.53 4.601 5.8 9.713 6.64 15.422.589 3.58.42 7.243.168 10.822-.756 8.35-3.446 16.018-7.397 23.346-2.017 3.749-4.034 7.413-5.968 11.162-1.176 2.216-1.933 4.602-2.101 7.158-.168 1.704.168 3.323.672 4.856a586.17 586.17 0 004.96 12.952c.588 1.534 1.26 3.067 1.849 4.601.84 2.045.336 3.664-1.429 5.027-1.765 1.364-3.867 2.045-5.968 2.556-3.782.938-7.649 1.279-11.6 1.364-2.942.085-5.884.085-8.91.085-4.875-.085-9.834-.341-14.541-1.789-1.681-.512-3.278-1.108-4.623-2.216-1.766-1.363-2.186-2.982-1.43-5.027 1.598-4.09 3.363-8.095 4.96-12.099.925-2.471 1.681-5.027 2.354-7.669.588-2.386.084-4.686-.757-6.987-1.177-3.238-2.858-6.22-4.539-9.287-2.438-4.346-4.791-8.777-6.556-13.463-1.597-4.26-2.69-8.606-3.194-13.122-.253-3.493-.42-7.157 0-10.736.756-6.731 3.362-12.78 7.817-18.064 2.942-3.493 6.388-6.475 10.507-8.776 1.008-.511 1.513-1.363 1.429-2.471v-8.01c0-.852-.252-1.107-1.177-1.277-3.026-.512-5.968-1.193-8.742-2.471-.504-.256-1.009-.512-1.429-.767-1.513-.938-2.353-2.13-2.27-4.005.169-2.556.085-5.198 0-7.754 0-.937.337-1.704 1.01-2.3 1.176-1.108 2.69-1.79 4.202-2.386 3.11-1.193 6.388-1.79 9.667-2.216 4.79-.766 9.75-.852 14.625-.681 5.884.255 11.768.852 17.4 2.897 1.513.511 2.942 1.193 4.119 2.3.756.682 1.092 1.449 1.092 2.471-.084 1.364-.084 2.727-.084 4.09z",
    fill: "url(#ilustra-404-eudora_svg__paint5_linear)",
    fillOpacity: 0.2,
    stroke: "url(#ilustra-404-eudora_svg__paint6_linear)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-404-eudora_svg__paint0_linear",
    x1: 20.404,
    y1: 18.004,
    x2: 15.02,
    y2: 14.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-404-eudora_svg__paint1_linear",
    x1: 99.081,
    y1: 22.994,
    x2: 103.6,
    y2: 17.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-404-eudora_svg__paint2_linear",
    x1: 103.593,
    y1: 54.156,
    x2: 116.988,
    y2: 49.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-404-eudora_svg__paint3_linear",
    x1: 1.022,
    y1: 54.156,
    x2: 14.417,
    y2: 49.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-404-eudora_svg__paint4_linear",
    x1: 62.824,
    y1: 15.529,
    x2: 58.035,
    y2: 1.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-404-eudora_svg__paint5_linear",
    x1: 29.471,
    y1: 176,
    x2: 95.57,
    y2: 175.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-404-eudora_svg__paint6_linear",
    x1: 29.471,
    y1: 176,
    x2: 95.57,
    y2: 175.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })))));
}
export default SvgIlustra404Eudora;